export const platformManaged = 'EDAP';
export default {};
